import axios from 'axios';
import toCamelCase from '@/helpers/toCamelCase';
import toSnakeCase from '@/helpers/toSnakeCase';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    items: [],
    promises: {}
});

export const getters = {
    items: state => state.items,
    promises: state => state.promises,
};

export const mutations = {
    SET_ITEM(state, item) {
        const index = state.items.findIndex(i => i.statusId === item.statusId);
        if (index >= 0) {
            state.items.splice(index, 1, cloneDeep(item));
        } else {
            state.items.push(item);
        }
    },

    SET_PROMISE(state, { id, promise }) {
        state.promises[id] = promise;
    },
};

export const actions = {
    async getItem({ commit, getters }, { id }) {
        let promise = getters.promises[id];

        const item = getters.items.find(i => `${i.statusId}` === `${id}`);
        if (item) {
            promise = new Promise(resolve => resolve(item));
        }

        if (promise === undefined) {
            promise = new Promise(
                (resolve, reject) => {
                    axios
                        .$get(`/v1/statuses/${id}`)
                        .then((item) => {
                            commit('SET_ITEM', toCamelCase(item));
                            resolve(toCamelCase(item));
                        })
                        .catch((e) => reject(e))
                        .finally(() => commit('SET_PROMISE', { id, undefined }));
                }
            );

            commit('SET_PROMISE', { id, promise });
        }

        return promise;
    },

    async getItems(vuexContext, { query, filters, offset = 0, limit = 15, order_by = 'counts.total_engagements', direction = 'desc' }) {
        return new Promise(
            (resolve, reject) => {
                axios
                    .$post(`/v1/statuses`, {
                        args: {
                            order_by: order_by,
                            direction: direction
                        },
                        query: JSON.stringify(toSnakeCase(query)),
                        filters: JSON.stringify(toSnakeCase(filters)),
                        offset,
                        limit
                    })
                    .then((response) => {
                        resolve(toCamelCase(response.data));
                    })
                    .catch((e) => reject(e));
            }
        );
    },

    async getCounts(vuexContext, { query, filters }) {
        return new Promise(
            (resolve, reject) => {
                axios
                    .$get(`/v1/statuses/counts`, {
                        params: {
                            query: JSON.stringify(toSnakeCase(query)),
                            filters: JSON.stringify(toSnakeCase(filters)),
                        }
                    })
                    .then((response) => {
                        resolve(toCamelCase(response.data));
                    })
                    .catch((e) => reject(e));
            }
        );
    }
};
